import { Map } from "immutable";

const constantState = new Map({
  "temperature-differentials": { organisations: [1] }
});

export default function reducer(state = constantState) {
  return state;
}
